angular.module('gym.grading').controller('ShowGradingCtrl', ["$scope", "grading", function($scope, grading) {
  return $scope.grading = grading;
}]);
